import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./ServicePages.css";
import "../PrivateLimitedCompany.css";

const RodtepScheme = () => {
 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }



  return (
    <div className="service-page">

      {/* HERO */}
      <div className="hero">

        <h1>RoDTEP Scheme Assistance Services</h1>

        <p className="subtitle">
          Get Export Incentives Under RoDTEP Scheme
        </p>

        <p className="desc">
          Maximize Your Benefits on Every Export Shipment
        </p>

        <p className="desc">
          We help exporters claim benefits under the RoDTEP scheme with proper documentation and compliance support, ensuring you don’t miss out on government export incentives.
        </p>

        <div className="badges">
          <span>✔ Expert Export Compliance Support</span>
          <span>✔ Faster Incentive Processing</span>
          <span>✔ End-to-End Documentation Help</span>
          <span>✔ Hassle-Free Filing</span>
        </div>

       <div className="hero-action">
                    <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
                </div>


      </div>

      {/* WHAT IS RODTEP */}
      <div className="section">
        <h2>What is RoDTEP?</h2>
        <p>
          Directorate General of Foreign Trade (DGFT) introduced the RoDTEP (Remission of Duties and Taxes on Exported Products) scheme to refund hidden taxes and duties paid on exported goods.
        </p>
        <p>
          It ensures exporters are reimbursed for taxes that are not refunded under other schemes.
        </p>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of RoDTEP Scheme</h2>
        <ul>
          <li>Refund of embedded taxes and duties</li>
          <li>Improves export profitability</li>
          <li>Enhances global competitiveness</li>
          <li>Automated credit in electronic ledger</li>
          <li>Applicable across multiple export sectors</li>
          <li>Reduces overall export cost</li>
        </ul>
      </div>

      {/* WHO CAN APPLY */}
      <div className="section">
        <h2>Who Can Apply for RoDTEP?</h2>
        <ul>
          <li>Exporters of goods from India</li>
          <li>Manufacturing companies</li>
          <li>Trading export businesses</li>
          <li>MSME exporters</li>
          <li>E-commerce exporters shipping goods abroad</li>
        </ul>
      </div>

      {/* PRODUCTS */}
      <div className="section">
        <h2>Products Covered</h2>
        <ul>
          <li>Engineering goods</li>
          <li>Chemical products</li>
          <li>Textiles & garments</li>
          <li>Food products</li>
          <li>Leather goods</li>
          <li>Handicrafts</li>
          <li>Agricultural products</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our RoDTEP Services Include</h2>
        <ul>
          <li>Eligibility Assessment</li>
          <li>Documentation Support</li>
          <li>Shipping Bill Mapping</li>
          <li>Export Data Verification</li>
          <li>Claim Filing Assistance</li>
          <li>DGFT Portal Support</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>
        <ul>
          <li>Import Export Code (IEC)</li>
          <li>GST Registration Certificate</li>
          <li>Shipping Bills</li>
          <li>Export Invoices</li>
          <li>Bank Account Details</li>
          <li>Product Classification (HS Code)</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>RoDTEP Claim Process</h2>
        <ol>
          <li>Consultation – Check eligibility for your exports</li>
          <li>Data Collection – Gather shipping & invoice details</li>
          <li>Filing Support – Map data with DGFT system</li>
          <li>Verification – Validate export records</li>
          <li>Credit Allocation – Receive RoDTEP benefits in ledger</li>
        </ol>
      </div>

      {/* WHY CHOOSE US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Export Incentive Experts</li>
          <li>Accurate Claim Filing</li>
          <li>Fast Processing Support</li>
          <li>Compliance Assurance</li>
          <li>End-to-End Assistance</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>
        <p><b>Is RoDTEP mandatory for exporters?</b> No, but it provides financial benefits on eligible exports.</p>
        <p><b>How is RoDTEP benefit received?</b> As electronic duty credit in your DGFT ledger.</p>
        <p><b>Can all products claim RoDTEP?</b> No, only notified products are eligible.</p>
        <p><b>Is IEC required for RoDTEP?</b> Yes, IEC is mandatory.</p>
      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef}>
        <h2>Don’t Miss Your Export Incentives</h2>
        <p>Claim your RoDTEP benefits with expert support.</p>

                   <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
      </div>

    </div>
  );
};

export default RodtepScheme;